import { ServiceUiModal } from 'state/service/ui';

export function closeGlobalModal(): BaseTockAction {
  return {
    type: 'CLOSE_GLOBAL_MODAL',
  };
}

export function openGlobalModal(type: ServiceUiModal): BaseTockAction {
  return {
    type: 'OPEN_GLOBAL_MODAL',
    payload: type,
  };
}

export function closeProfileModal(): BaseTockAction {
  return {
    type: 'CLOSE_PROFILE_MODAL',
  };
}

export function openProfileModal(): BaseTockAction {
  return {
    type: 'OPEN_PROFILE_MODAL',
  };
}
